var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32009_1428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 1.41961C0.599609 0.63558 1.23519 0 2.01922 0H19.1801C19.9641 0 20.5997 0.635581 20.5997 1.41961V18.5804C20.5997 19.3644 19.9641 20 19.1801 20H2.01922C1.23519 20 0.599609 19.3644 0.599609 18.5804V1.41961Z",
    fill: "#C6CBD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08852 6.21683C6.04673 6.21683 6.82352 5.44004 6.82352 4.48183C6.82352 3.52361 6.04673 2.74683 5.08852 2.74683C4.1303 2.74683 3.35352 3.52361 3.35352 4.48183C3.35352 5.44004 4.1303 6.21683 5.08852 6.21683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41248 7.49904H11.2879V8.8163C11.2879 8.8163 12.0682 7.25571 14.1913 7.25571C16.0852 7.25571 17.654 8.18868 17.654 11.0324V17.0291H14.6742V11.7591C14.6742 10.0815 13.7786 9.89702 13.0962 9.89702C11.6798 9.89702 11.4374 11.1187 11.4374 11.9779V17.0291H8.41248V7.49904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57607 7.49905H6.60096V17.0291H3.57607V7.49905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32009_1428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin_white.6bb9d7f991bc406dc1f8f681d3283530.svg";
export { ForwardRef as ReactComponent };